import React, { useState } from "react";
import style from "./AddProduct.module.css";
import axios from "axios";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
export const AddProduct = () => {
  const [newProduct, setNewProduct] = useState({
    codigo: undefined,
    producto: undefined,
    foto: undefined,
    peso: undefined,
    altura: undefined,
    diametrosup: undefined,
    diametroinf: undefined,
    duracion: undefined,
    ancho: undefined,
    largo: undefined,
  });

  const useStyles = makeStyles((theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [open5, setOpen5] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
    setOpen5(false);
  };

  const UpdateProduct = (e) => {
    const update = {
      codigo: newProduct.codigo,
      producto: newProduct.producto,
      foto: newProduct.foto,
      peso: newProduct.peso,
      altura: newProduct.altura,
      diametrosup: newProduct.diametrosup,
      diametroinf: newProduct.diametroinf,
      duracion: newProduct.duracion,
      ancho: newProduct.ancho,
      largo: newProduct.largo,
    };

    if (
      update.codigo.length > 0 &&
      update.producto.length > 0 &&
      update.foto.length > 0 &&
      update.peso.length > 0 &&
      update.altura.length > 0 &&
      update.diametrosup.length > 0 &&
      update.diametroinf.length > 0 &&
      update.duracion.length > 0 &&
      update.ancho.length > 0 &&
      update.largo.length > 0
    ) {
      axios
        .post("https://iluminarte3.herokuapp.com/admin/update", update)
        .then((response) => {
          if (response.status === 200) setOpen(true);
          else if (response.status === 500) setOpen2(true);
        })
        .catch((error) => setOpen2(true));
    } else setOpen4(true);
    return;
  };

  const CreateProduct = async () => {
    const creating = {
      codigo: newProduct.codigo,
      producto: newProduct.producto,
      foto: newProduct.foto,
      peso: newProduct.peso,
      altura: newProduct.altura,
      diametrosup: newProduct.diametrosup,
      diametroinf: newProduct.diametroinf,
      duracion: newProduct.duracion,
      ancho: newProduct.ancho,
      largo: newProduct.largo,
    };

    if (
      creating.codigo.length > 0 &&
      creating.producto.length > 0 &&
      creating.foto.length > 0 &&
      creating.peso.length > 0 &&
      creating.altura.length > 0 &&
      creating.diametrosup.length > 0 &&
      creating.diametroinf.length > 0 &&
      creating.duracion.length > 0 &&
      creating.ancho.length > 0 &&
      creating.largo.length > 0
    ) {
      await axios
        .post("https://iluminarte3.herokuapp.com/admin/create", creating)
        .then((response) => {
          if (response.status === 200) setOpen3(true);
          else if (response.status === 400) setOpen5(true);
          console.log(response.status);
        });
    } else setOpen4(true);

    return;
  };

  let handler = (e) => {
    setNewProduct({
      ...newProduct,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className={style.container}>
      <h1 className={style.title}>Agregar o modificar Producto</h1>
      <p className={style.text}>
        Utiliza el codigo del producto para crear o modificar uno existente
      </p>
      <div className={style.form}>
        <div className={style.allInput}>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="codigo"
              name="codigo"
              type="text"
              className={style.input}
              placeholder="Codigo"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="producto"
              name="producto"
              type="text"
              className={style.input}
              placeholder="Nombre"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="foto"
              name="foto"
              type="number"
              className={style.input}
              placeholder="Foto"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="peso"
              name="peso"
              type="number"
              className={style.input}
              placeholder="Peso"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="altura"
              name="altura"
              type="number"
              className={style.input}
              placeholder="Altura"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="diametrosup"
              name="diametrosup"
              type="number"
              className={style.input}
              placeholder="Diametro Superior"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="diametroinf"
              name="diametroinf"
              type="number"
              className={style.input}
              placeholder="Diametro Inferior"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="duracion"
              name="duracion"
              type="number"
              className={style.input}
              placeholder="Duracion"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="ancho"
              name="ancho"
              type="number"
              className={style.input}
              placeholder="Ancho"
              required
            />
          </div>
          <div className={style.inputCont}>
            <input
              onChange={handler}
              id="largo"
              name="largo"
              type="number"
              className={style.input}
              placeholder="Largo"
              required
            />
          </div>
        </div>
        <div className={style.btnCont}>
          <Button
            variant="contained"
            color="primary"
            onClick={CreateProduct}
            className={style.btn}
            disabled={false}
          >
            Agregar Producto
          </Button>

          <Button
            variant="contained"
            color="secondary"
            onClick={UpdateProduct}
            className={style.btn}
          >
            Modificar Producto
          </Button>
        </div>
      </div>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Producto modificado</h2>
              <p id="transition-modal-description">Todo ha salido bien!</p>
            </div>
          </Fade>
        </Modal>
      </div>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open2}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open2}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">El producto no existe</h2>
              <p id="transition-modal-description">
                Escribe bien el codigo o crea un producto nuevo!
              </p>
            </div>
          </Fade>
        </Modal>
      </div>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open3}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open3}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Producto creado.</h2>
              <p id="transition-modal-description">Todo ha salido bien!</p>
            </div>
          </Fade>
        </Modal>
      </div>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open4}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open4}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Ups, error.</h2>
              <p id="transition-modal-description">
                Completa todos los campos e intenta nuevamente
              </p>
            </div>
          </Fade>
        </Modal>
      </div>

      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open5}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open5}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Ups, error.</h2>
              <p id="transition-modal-description">
                El codigo de producto ya existe.
              </p>
            </div>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};
